import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails, Avatar, Typography } from '@mui/material';

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  border: `2px solid ${hasError ? theme.palette.error.main : 'transparent'}`,
  transition: theme.transitions.create(['border-color'])
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  '& > div': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

export const TitleContainer = styled('div')({
  display: 'flex'
});

export const Title = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 24,
  height: 24,
  fontSize: 'small'
}));

export const StyledAccordionDetails = styled(AccordionDetails)({
  display: 'flex',
  flexDirection: 'column'
});
